import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            影视分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型浏览你感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {movieCategories.map((cat) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/50 hover:border-accent-500/40 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-500/10 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${cat.icon} text-accent-400 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                海量{cat.name}资源
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}